import { Company, CompanyFormData } from "@/types/company";
import { PageRes, apiRequest } from "./api";

const COMPANY_URL = "/app/companies";

const companyService = {
  async getAll(search?: string, page?: number, limit?: number): Promise<[PageRes<Company> | null, any]> {
    const params: Record<string, string | number> = {};
    if (search) params.search = search;
    if (page) params.page = page;
    if (limit) params.limit = limit;

    return apiRequest<PageRes<Company>>({
      loaderKey: "companies",
      method: "get",
      url: COMPANY_URL,
      params,
    });
  },

  async getById(id: string): Promise<[Company | null, any]> {
    return apiRequest<Company>({
      loaderKey: "company",
      method: "get",
      url: `${COMPANY_URL}/${id}`,
    });
  },

  async create(data: CompanyFormData): Promise<[any, any]> {
    return apiRequest({
      loaderKey: "createCompany",
      method: "post",
      url: COMPANY_URL,
      data,
    });
  },

  async update(id: string, data: Partial<CompanyFormData>): Promise<[any, any]> {
    return apiRequest({
      loaderKey: "updateCompany",
      method: "put",
      url: `${COMPANY_URL}/${id}`,
      data,
    });
  },
};

export default companyService;
